import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

export function Logo() {
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <div className="w-8 h-8 rounded-lg bg-charcoal-900 grid place-items-center">
        <ShieldCheck className="w-4.5 h-4.5 text-emerald-400" strokeWidth={2} />
      </div>
      <span className="font-semibold tracking-tight text-charcoal-900 text-[15px]">Mission Watch</span>
    </div>
  );
}

function scrollToId(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function Header({ onSampleReport }) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const nav = [
    { label: "How it works", id: "how" },
    { label: "What's included", id: "included" },
    { label: "Pricing", id: "pricing" },
    { label: "FAQ", id: "faq" },
  ];
  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <button onClick={() => scrollToId("top")} className="cursor-pointer" data-testid="nav-home">
          <Logo />
        </button>
        <nav className="hidden md:flex items-center gap-8">
          {nav.map((n) => (
            <button key={n.id} onClick={() => scrollToId(n.id)}
              className="text-sm text-charcoal-500 hover:text-charcoal-900 transition-colors"
              data-testid={`nav-${n.id}`}>
              {n.label}
            </button>
          ))}
        </nav>
        <div className="flex items-center gap-2.5">
          {user ? (
            <button onClick={() => navigate("/dashboard")}
              className="text-sm font-medium px-4 py-2 rounded-full bg-charcoal-900 text-white hover:bg-charcoal-800 transition-colors"
              data-testid="nav-dashboard-btn">
              Dashboard
            </button>
          ) : (
            <>
              <button onClick={() => navigate("/login")}
                className="hidden sm:inline text-sm text-charcoal-600 hover:text-charcoal-900 px-3 py-2 transition-colors"
                data-testid="nav-login-btn">
                Sign in
              </button>
              <button onClick={() => navigate("/register")}
                className="text-sm font-medium px-4 py-2 rounded-full bg-brand text-white hover:bg-brand-hover transition-colors shadow-soft"
                data-testid="nav-signup-btn">
                Run My Free Health Check
              </button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
